<template>
    <div class="styling_wrapper">
        <div class="row">
            <div class="col-md-4">
                <h3 class="h5  mb-4">Primary Heading</h3>
            </div>
            <div class="col-md-8">
                <h1>Heading 1</h1>
                <h2>Heading 2</h2>
                <h3>Heading 3</h3>
                <h4>Heading 4</h4>
                <h5>Heading 5</h5>
                <h6>Heading 6</h6>
            </div>
        </div>
        <hr class="my-5">
        <div class="row">
            <div class="col-md-4">
                <h3 class="h5  mb-4">Paragraph</h3>
            </div>
            <div class="col-md-8">
                <p>
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.
                </p>
            </div>
        </div>
        <hr class="my-5">
        <div class="row">
            <div class="col-md-4">
                <h3 class="h5 mb-4">Font Family</h3>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-md-6">
                        <h4 class="fw-bold">Plus Jakarta Sans</h4>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                        </p>
                    </div>
                    <div class="col-md-6 font-monospace">
                        <h4 class="fw-bold">Roboto Sans</h4>
                        <p>
                            Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.
                        </p>
                    </div>
                </div>                
            </div>
        </div>
        <hr class="my-5">
        <div class="row">
            <div class="col-md-4">
                <h3 class="h5 mb-4">Colors</h3>
            </div>
            <div class="col-md-8">
                <div class="row">
                    <div class="col-4 text-center">
                        <div class="color_box" style="--bg-color: var(--primary);"></div>
                        <p>Primary</p>
                    </div>
                    <div class="col-4 text-center">
                        <div class="color_box" style="--bg-color: var(--secondary);"></div>
                        <p>Secondary</p>
                    </div>
                    <div class="col-4 text-center">
                        <div class="color_box" style="--bg-color: var(--body-bg);"></div>
                        <p>Background</p>
                    </div>
                </div>   
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
    }
}

</script>
<style lang="scss">

.styling_wrapper{
    padding: calc(4 * var(--gutter)) var(--gutter);    
}
.color_box{
    margin-bottom: 12px;
    border-radius: 100px;
    width: 100%;
    height: 5rem;    
    background-color: var(--bg-color);
}
</style>


// WEBPACK FOOTER //
// src/views/portfolio/Content/Style.vue